import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

const CONTROLLER_PATH = `${SERVICE_ENDPOINT.TRANSPORT}/mission-control`;

export const missionControlSearch = async (searchText) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/search/${searchText}`,
    );
    let mappedResults = {};

    for (let res of response.data) {
      mappedResults = {
        ...mappedResults,
        [res.type]: mappedResults[res.type]
          ? {
              ...mappedResults[res.type],
              results: [
                ...mappedResults[res.type].results,
                {
                  title: res.foundValue,
                  value: res.id,
                  category: res.category,
                },
              ],
            }
          : {
              name: res.type,
              results: [
                {
                  title: res.foundValue,
                  value: res.id,
                  category: res.category,
                },
              ],
            },
      };
    }

    return mappedResults;
  } catch (e) {
    console.error(e);
  }
};

export const filterGpsVehicles = async (data) => {
  try {
    console.log("PAYLOAD:", JSON.stringify(data));
    const response = await gatewayInstance.post(
      `${CONTROLLER_PATH}/filter`,
      data,
    );

    return response.data.filter(
      (item, index, array) =>
        index ===
        array.findIndex((findItem) => findItem.vehicleNo === item.vehicleNo),
    );
  } catch (e) {
    console.error(e);
  }
};

export const getVehicleJob = async (vehicleNo) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/vehicle-job/${vehicleNo}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getBatchVehicleJobs = async (vehicleNos) => {
  try {
    const response = await gatewayInstance.post(
      `${CONTROLLER_PATH}/vehicle-jobs/batch`,
      vehicleNos
    );
    return response.data || {};
  } catch (e) {
    console.error("Batch vehicle fetch failed", e);
    throw e;
  }
};

export const fetchBatchVehicleJobs = async (response) => {
  if (!response || !Array.isArray(response) || response.length === 0) return {};
  const vehicleNos = [...new Set(response.map((r) => r.vehicleNo).filter(Boolean))];
  if (vehicleNos.length === 0) return {};

  try {
    const batchMap = await getBatchVehicleJobs(vehicleNos);
    const jobInfo = {};
    for (let row of response) {
      if (batchMap && batchMap[row.vehicleNo]) {
        jobInfo[row.terminalId] = batchMap[row.vehicleNo];
      }
    }
    return jobInfo;
  } catch (err) {
    console.warn("Falling back to parallel fetch for vehicle jobs", err);
    const jobInfo = {};
    await Promise.all(
      response.map(async (row) => {
        try {
          const data = await getVehicleJob(row.vehicleNo);
          jobInfo[row.terminalId] = data;
        } catch (e) {}
      })
    );
    return jobInfo;
  }
};

export const saveMissionControlAction = async (data) => {
  const response = await gatewayInstance.post(
    `${CONTROLLER_PATH}/action`,
    data,
  );
  return response.data;
};

export const getActionByJob = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/action/${jobId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const saveMissionControlCall = async (data) => {
  const response = await gatewayInstance.post(
    `${CONTROLLER_PATH}/call-log`,
    data,
  );
  return response.data;
};

export const getCallsByJob = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/call-log/${jobId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getJobLocations = async (jobId) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/job-location/${jobId}`,
    );
    return response.data.sort((loc1, loc2) => loc1.locSeq - loc2.locSeq);
  } catch (e) {
    console.error(e);
  }
};

export const getJobLocationTimeUpdates = async (jobId, locId) => {
  try {
    const response = await gatewayInstance.get(
      `${CONTROLLER_PATH}/job-location-time-update/${jobId}/${locId}`,
    );

    return response.data.sort((loc1, loc2) => loc1.planedSeq - loc2.planedSeq);
  } catch (e) {
    console.error(e);
  }
};



// Mission Control Filters API for Dropdowns
export const getCustomersSearchDropdown = async (params) => {
  const searchText = typeof params === 'string' ? params : params?.searchText;
  try {
    const response = await gatewayInstance.get(`${CONTROLLER_PATH}/filter/customers`);
    const data = response.data || [];
    let filtered = data;
    if (searchText) {
      filtered = data.filter(c => 
        (c.customerName || "").toLowerCase().includes(searchText.toLowerCase())
      );
    }
    const uniqueMap = new Map();
    filtered.forEach(item => {
      if (item.customerId && !uniqueMap.has(item.customerId)) {
        uniqueMap.set(item.customerId, {
          key: item.customerId,
          title: item.customerName,
          value: item.customerId
        });
      }
    });
    return Array.from(uniqueMap.values());
  } catch(e) { console.error(e); return []; }
};

export const getDestinationsSearchDropdown = async (params) => {
  const searchText = typeof params === 'string' ? params : params?.searchText;
  try {
    const response = await gatewayInstance.get(`${CONTROLLER_PATH}/filter/locations`);
    const data = response.data || [];
    let filtered = data;
    if (searchText) {
      filtered = data.filter(l => 
        (l.locationName || "").toLowerCase().includes(searchText.toLowerCase())
      );
    }
    const uniqueMap = new Map();
    filtered.forEach(item => {
      if (item.locationId && !uniqueMap.has(item.locationId)) {
        uniqueMap.set(item.locationId, {
          key: item.locationId,
          title: item.locationName,
          value: item.locationId
        });
      }
    });
    return Array.from(uniqueMap.values());
  } catch(e) { console.error(e); return []; }
};

export const getVehiclesSearchDropdown = async (params) => {
  const searchText = typeof params === 'string' ? params : params?.searchText;
  try {
    const response = await gatewayInstance.get(`${CONTROLLER_PATH}/filter/vehicles`);
    const data = response.data || [];
    let filtered = data;
    if (searchText) {
      filtered = data.filter(v => 
        (v.vehicleRegNo || "").toLowerCase().includes(searchText.toLowerCase())
      );
    }
    const uniqueMap = new Map();
    filtered.forEach(item => {
      if (item.vehicleId && !uniqueMap.has(item.vehicleId)) {
        uniqueMap.set(item.vehicleId, {
          key: item.vehicleId,
          title: item.vehicleRegNo,
          value: item.vehicleId
        });
      }
    });
    return Array.from(uniqueMap.values());
  } catch(e) { console.error(e); return []; }
};

export const getJobsSearchDropdown = async (params) => {
  const searchText = typeof params === 'string' ? params : params?.searchText;
  try {
    const response = await gatewayInstance.get(`${CONTROLLER_PATH}/filter/jobs`);
    const data = response.data || [];
    let filtered = data;
    if (searchText) {
      filtered = data.filter(j => 
        (j.jobCode || "").toLowerCase().includes(searchText.toLowerCase())
      );
    }
    const uniqueMap = new Map();
    filtered.forEach(item => {
      if (item.jobId && !uniqueMap.has(item.jobId)) {
        uniqueMap.set(item.jobId, {
          key: item.jobId,
          title: item.jobCode,
          value: item.jobId
        });
      }
    });
    return Array.from(uniqueMap.values());
  } catch(e) { console.error(e); return []; }
};
